import type { CurrentUserAvatarProps } from "./current-user-avatar.type";

import { useGetCurrentUser } from "@/entities/current-user";
import { UserAvatar } from "@/ui/user-avatar";

export const CurrentUserAvatar = (props: CurrentUserAvatarProps) => {
  const { currentUser } = useGetCurrentUser();

  return currentUser?.id ? <UserAvatar {...props} user={currentUser} /> : null;
};
